import { call, put, select, takeEvery } from 'redux-saga/effects'

import {
  agentSourcedCreatorActionFailure,
  agentSourcedCreatorActionSuccess,
  shortlistAgentSourcedCreator,
} from '@store/agentSourcedCreators/actions'
import { selectAgentSourcedCreators } from '@store/agentSourcedCreators/selectors'
import { selectAuthToken } from '@store/auth/selectors'
import { extractVerbatimErrorMessage } from '@store/discoveryRuns/api'
import { toast } from '@tribegroup'
import { networkRequest } from '@utils/networkRequest'

const creatorDisplayName = (creators: ReadonlyArray<any>, id: number): string => {
  const c = creators.find((x) => x.id === id)
  return (
    c?.creator_data?.fullname ?? c?.creator_data?.handle ?? c?.creator_data?.username ?? 'Creator'
  )
}

export function* shortlistCreatorSaga(action: ReturnType<typeof shortlistAgentSourcedCreator>) {
  try {
    const { creatorId, href, method } = action.payload
    const token: string = yield select(selectAuthToken)
    const response: {
      id: number
      status: string
      shortlisted: boolean
      links: unknown
    } = yield call(networkRequest, method, href, undefined, token)
    yield put(
      agentSourcedCreatorActionSuccess({
        creatorId,
        status: response.status as any,
        shortlisted: response.shortlisted ?? true,
        updatedLinks: response.links as any,
      }),
    )
    const creators: ReadonlyArray<any> = yield select(selectAgentSourcedCreators)
    yield call(toast, `Shortlisted ${creatorDisplayName(creators, creatorId)}`)
  } catch (e: any) {
    const message = extractVerbatimErrorMessage(e)
    yield put(
      agentSourcedCreatorActionFailure({
        creatorId: action.payload.creatorId,
        error: message,
      }),
    )
    yield call(toast, `Shortlist failed: ${message}`)
  }
}

export default function* watchShortlistAgentSourcedCreator() {
  yield takeEvery(shortlistAgentSourcedCreator.type, shortlistCreatorSaga)
}
